export default "__VITE_ASSET__Ba5Ru3B7__"